module.exports = __webpack_public_path__ + "static/media/facet-all-protections-icon.54c34c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/facet-all-protections-icon.png
// module id = 282
// module chunks = 0